import { View, ViewType } from "@common/types/views/views";

export enum HistoryCatalogItemDetailsColumn {
    TIME = "time",
    ITEM_NAME = "itemName",
    FIELD = "field",
    PREVIOUS = "previous",
    MODIFIED = "modified",
}

export enum HistoryCatalogItemTableKind {
    IDENTITY = "identity",
    CHANGE = "change",
}

export interface HistoryCatalogItemDetailsView extends View {
    type: ViewType.HISTORY_UPDATED_TRANSACTION;
    columns: Array<{ id: HistoryCatalogItemDetailsColumn }>;
}
